if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.productGridSelector = '[data-items-grid]';
        this.productCountTextEl = this.querySelector('[data-product-count-text]');
        if (this.productCountTextEl) {
          this.productCountPagedTextEl = this.productCountTextEl.querySelector('[data-product-count-paged]');
        }
        this.button = this.querySelector('[data-load-more-button]');
        this.loadingSpinner = this.querySelector('.loading__spinner');
        if (this.button) {
          this.button.addEventListener('click', this.handleButtonClick.bind(this));
        }
      }

      set loading(loading) {
        this._loading = loading;
        if (this.button) {
          this.button.classList.toggle('loading', loading);
        }
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.toggle('hidden', !loading);
        }
      }

      get loading() {
        return this._loading;
      }

      handleButtonClick(e) {
        e.preventDefault();
        this.loadNextPage();
      }

      async loadNextPage() {
        if (this.button == null || this.loading) return;
        this.loading = true;
        const url = this.button.href;
        const response = await fetch(url);
        const html = await response.text();
        const parsedResponse = new DOMParser().parseFromString(html, 'text/html');
        const parsedProductGridEl = parsedResponse.querySelector(this.productGridSelector);
        const ogProductGridEl = document.querySelector(this.productGridSelector);
        const newLoadMoreEl = parsedResponse.querySelector('collection-load-more');
        const parsedProductGridChildren = [...parsedProductGridEl.children];

        if (parsedProductGridChildren.length) {
          parsedProductGridChildren.forEach((child) => {
            const clonedChild = child.cloneNode(true);
            ogProductGridEl.append(clonedChild);
          });
        }

        if (this.productCountPagedTextEl) {
          this.productCountPagedTextEl.innerText = ogProductGridEl.children.length;
        }

        if (newLoadMoreEl) {
          const newLoadMoreButton = newLoadMoreEl.querySelector('[data-load-more-button]');
          this.button.href = newLoadMoreButton.href;
          this.loading = false;
        }
        else {
          this.button.remove();
          this.loading = false;
        }
      }
    }
  );
}
